var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcuador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 8H0v3.998h24V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 11.997H0v3.998h24v-3.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 10.783a2.78 2.78 0 002.57-3.848A2.783 2.783 0 1012 10.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 9.845a1.8 1.8 0 01-1.793-1.793v-1.08a1.793 1.793 0 013.585 0v1.08A1.8 1.8 0 0112 9.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.872 3.747H12.75a.75.75 0 10-1.44 0H9.127a.75.75 0 00.75.713.75.75 0 00.75.75.75.75 0 00.713.75h1.41a.75.75 0 00.712-.75.75.75 0 00.75-.75.75.75 0 00.66-.713z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcuador);
export default __webpack_public_path__ + "static/media/Ecuador.c1b9432b2c85df38fd0376cf95093b39.svg";
export { ForwardRef as ReactComponent };